import { render, staticRenderFns } from "./BDXManagementTableFiltersRECStatus.vue?vue&type=template&id=296b54ac"
import script from "./BDXManagementTableFiltersRECStatus.vue?vue&type=script&lang=js"
export * from "./BDXManagementTableFiltersRECStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports